export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-doc-d9700effc9474473db14c144e79cfbf6.svg";